(function(){
  const DEBUG = window.location.search.includes('consent_debug=true');
  
  function log(...args) {
    if (DEBUG) console.log('[KIANUSH Integrations]', ...args);
  }

  // Get configuration from theme settings (injected via theme.liquid)
  const SETTINGS = window.KIANUSH_CONSENT_SETTINGS || {};
  const config = {
    GTM_ID: SETTINGS.gtm_id || null,           // From theme settings
    GA4_ID: SETTINGS.ga4_id || null,           // From theme settings
    CLARITY_ID: SETTINGS.clarity_id || null,   // From theme settings
    META_PIXEL_ID: SETTINGS.meta_pixel_id || null, // From theme settings
    TIKTOK_PIXEL_ID: null                      // Can add to settings if needed
  };

  // Enhanced environment detection - only run analytics in production
  const isProduction = () => {
    // Check Liquid-detected environment flag
    if (SETTINGS.is_production === false) {
      log('Development environment detected via Liquid (theme.role or design_mode)');
      return false;
    }
    
    // Check for preview bar (PBarNextFrameWrapper)
    if (document.querySelector('#PBarNextFrameWrapper')) {
      log('Development environment detected via preview bar');
      return false;
    }
    
    // Check for Shopify theme editor
    if (window.Shopify?.designMode) {
      log('Development environment detected via Shopify.designMode');
      return false;
    }
    
    // Check URL for preview parameters
    const url = window.location.href;
    if (url.includes('preview_theme_id') || url.includes('pb=0')) {
      log('Development environment detected via URL preview parameters');
      return false;
    }
    
    log('Production environment confirmed - analytics enabled');
    return true;
  };

  // Helper to load external scripts
  const loadScript = (src, attributes = {}) => {
    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    Object.entries(attributes).forEach(([key, value]) => {
      script.setAttribute(key, value);
    });
    document.head.appendChild(script);
    log(`Loaded script: ${src}`);
    return script;
  };

  // Google Analytics 4
  const startGA4 = () => {
    if (!config.GA4_ID) return;
    
    log('Starting Google Analytics 4...');
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${config.GA4_ID}`);
    
    window.dataLayer = window.dataLayer || [];
    function gtag(){ dataLayer.push(arguments); }
    window.gtag = gtag;
    
    gtag('js', new Date());
    gtag('config', config.GA4_ID, {
      anonymize_ip: true,
      cookie_flags: 'SameSite=None;Secure'
    });
    
    log('GA4 initialized:', config.GA4_ID);
  };

  // Google Tag Manager
  const startGTM = () => {
    if (!config.GTM_ID) return;
    
    log('Starting Google Tag Manager...');
    
    (function(w,d,s,l,i){
      w[l] = w[l] || [];
      w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', config.GTM_ID);
    
    log('GTM initialized:', config.GTM_ID);
  };

  // Microsoft Clarity
  const startClarity = () => {
    if (!config.CLARITY_ID) return;
    
    log('Starting Microsoft Clarity...');
    
    (function(c,l,a,r,i,t,y){
      c[a] = c[a] || function(){ (c[a].q = c[a].q || []).push(arguments) };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', config.CLARITY_ID);
    
    log('Clarity initialized:', config.CLARITY_ID);
  };

  // Meta/Facebook Pixel
  const startMetaPixel = () => {
    if (!config.META_PIXEL_ID) return;
    
    log('Starting Meta Pixel...');
    
    !function(f,b,e,v,n,t,s){
      if(f.fbq) return;
      n = f.fbq = function(){
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      };
      if(!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    
    fbq('init', config.META_PIXEL_ID);
    fbq('consent', 'grant');
    fbq('track', 'PageView');
    
    log('Meta Pixel initialized:', config.META_PIXEL_ID);
  };

  // TikTok Pixel
  const startTikTokPixel = () => {
    if (!config.TIKTOK_PIXEL_ID) return;
    
    log('Starting TikTok Pixel...');
    
    !function(w,d,t){
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];
      ttq.setAndDefer = function(t,e){
        t[e] = function(){
          t.push([e].concat(Array.prototype.slice.call(arguments,0)))
        }
      };
      for(var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function(t){
        for(var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e
      };
      ttq.load = function(e, n){
        var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = i;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date;
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        var o = document.createElement("script");
        o.type = "text/javascript";
        o.async = !0;
        o.src = i + "?sdkid=" + e + "&lib=" + t;
        var a = document.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(o, a);
      };
    }(window, document, 'ttq');
    
    ttq.load(config.TIKTOK_PIXEL_ID);
    ttq.page();
    
    log('TikTok Pixel initialized:', config.TIKTOK_PIXEL_ID);
  };

  // Handle consent updates
  let scriptsLoaded = false;
  
  const handleConsent = (event) => {
    const consent = event.detail || {};
    log('Handling consent update:', consent);
    
    // Check if we're in a production environment
    if (!isProduction()) {
      log('Analytics disabled in development environment');
      return;
    }
    
    // Prevent loading scripts multiple times
    if (scriptsLoaded) {
      log('Scripts already loaded, skipping...');
      return;
    }
    
    // Load analytics tools if consent given
    if (consent.analytics) {
      startGA4();
      startGTM();
      startClarity();
      scriptsLoaded = true;
    }
    
    // Load marketing tools if consent given
    if (consent.marketing) {
      startMetaPixel();
      startTikTokPixel();
      scriptsLoaded = true;
    }
  };

  // Listen for consent updates
  window.addEventListener('consent:update', handleConsent);

  // Check for existing consent on page load
  document.addEventListener('DOMContentLoaded', () => {
    log('Checking for existing consent...');
    
    // Check if we're in a production environment first
    if (!isProduction()) {
      log('Analytics disabled in development environment');
      return;
    }
    
    // Check localStorage for existing consent
    try {
      const stored = localStorage.getItem('consent.v1');
      if (stored) {
        const data = JSON.parse(stored);
        log('Found existing consent:', data);
        
        if (data.granted) {
          // Simulate consent update event
          handleConsent({ detail: data });
        }
      }
    } catch (e) {
      log('Error checking existing consent:', e);
    }
  });

  log('Integrations script ready');
})();